'use strict';

import $ from 'jquery';
import utilities from '../../js/utilities';
import mediator from '../../js/mediator';
import config from '../../js/config';
import $global from '../../js/globalElements';

const MOBILE_HEADER_HEIGHT = 87;
// From laptop breakpoint the header will be minimised.
const LAPTOP_HEADER_MINIMISED_HEIGHT = 40;
const SCROLL_TOP_PADDING = 20;
const DEFAULT_SCROLL_SPEED = 350;

export default class ScrollTo {
  /**
   * Construct the ScrollTo component.
   *
   * @param {jQuery} $el - The jQuery elements.
   */
  constructor($el) {
    this.$el = $el;
    this.initialize();
  }

  /**
   * Initialize the component.
   *
   * @fires config.events.scrollTo
   */
  initialize() {
    this.scrollSpeed = DEFAULT_SCROLL_SPEED;

    this.$el.on('click', (e) => {
      e.preventDefault();
      mediator.trigger(config.events.scrollTo, {
        selector: this.$el.attr('href'),
        scrollSpeed: this.scrollSpeed,
        offset: this.$el.data('scrollToOffset')
      });
    });

    mediator.on(config.events.scrollTo, ScrollTo.scrollToElement);
  }

  /**
   * Get the height of the header, based on the current viewport.
   *
   * @returns {number}
   */
  static getHeaderHeight() {
    return (window.innerWidth < config.breakpoints.laptop) ? MOBILE_HEADER_HEIGHT : LAPTOP_HEADER_MINIMISED_HEIGHT;
  }

  /**
   * Scroll to the specified element/
   *
   * @listens config.events.scrollTo
   * @param {Object} options
   * @param {string|HTMLElement} options.selector
   * @param {number} [options.position] - The position to scroll to - bypasses having to get the offset.
   * @param {number} [options.scrollSpeed = DEFAULT_SCROLL_SPEED] - The speed at which to scroll in milliseconds.
   * @param {boolean} [options.onlyScrollUp] - Whether to only scroll the viewport upwards.
   * @param {boolean} [options.onlyScrollDown] Whether to only scroll the viewport downwards.
   * @param {number} [options.offset = SCROLL_TOP_PADDING] - Additional offset when scrolling.
   */
  static scrollToElement(options) {
    let { selector, position, scrollSpeed = DEFAULT_SCROLL_SPEED, onlyScrollUp, onlyScrollDown, offset } = options;

    if (offset === undefined) {
      offset = SCROLL_TOP_PADDING;
    }

    position = (position || ScrollTo.getPosition(selector)) - ScrollTo.getHeaderHeight() - offset;

    // Avoid a reflow if not needed
    if (onlyScrollUp || onlyScrollDown) {
      let scrollTop = utilities.getScrollTop();
      if (onlyScrollUp && scrollTop <= position || onlyScrollDown && scrollTop >= position) {
        return;
      }
    }

    ScrollTo.scrollTo(position, scrollSpeed);
  }

  /**
   * Scroll to the specified vertical position on the page.
   *
   * @param {number} position - The position to scroll to.
   * @param {number} [scrollSpeed = DEFAULT_SCROLL_SPEED] - The speed at which to scroll in milliseconds.
   */
  static scrollTo(position, scrollSpeed = DEFAULT_SCROLL_SPEED) {
    if (!scrollSpeed) {
      $global.$htmlBody.scrollTop(position);
    } else {
      $global.$htmlBody.animate({
        scrollTop: position
      }, scrollSpeed);
    }
  }

  /**
   * Get the vertical position on the page of the selector.
   *
   * @param {string|HTMLElement} selector - The selector to get the position for.
   * @returns {number}
   */
  static getPosition(selector) {
    if (!(selector instanceof $)) {
      selector = $(selector);
    }

    return selector.offset().top;
  }
}

export function create($parent) {
  let $links = $parent.find('[data-scroll-to-element]');

  if (!$links.length) {
    return;
  }

  return new ScrollTo($links);
}



// WEBPACK FOOTER //
// ./assets/components/ScrollTo/ScrollTo.js